module.exports = __webpack_public_path__ + "puwenimg1.png?1642c4c326efe163fe0f82b894085bc9";